import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import user from './modules/user.js'

export default new Vuex.Store({
    //strict: process.env.NODE_ENV !== 'production', // 在非生产环境下，使用严格模式
    
    /* getters: {
        user: state => state.user
    }, */
    modules: {
        user
    }
    // state: {
    //     token: '333'
    // },
    // mutations: {
    //     // 同步修改状态数据的方法
    //     addToken(state, token) {
    //         state.token = token
    //     }
    // },
    // actions: {
    //     login({ commit }, token) {
    //         console.log(token, 'oooooooo')
    //         // 执行异步操作或其他逻辑
    //         // 可以通过commit调用mutation中的方法修改状态数据
    //         commit('addToken', token)
    //     }
    // },
    // getters: {
    // // 计算属性
    // }
})